// js/main.js
// 開機：標題畫面 → 選關 → 遊戲。處理螢幕尺寸與手機防縮放。

import { Game } from './core/Game.js';
import { TitleScreen } from './ui/TitleScreen.js';
import { LevelSelect } from './ui/LevelSelect.js';

const canvas = document.getElementById('stage');
const overlay = document.getElementById('overlay');

const title = new TitleScreen(overlay, {
  onStart: () => {
    title.hide();
    select.show();
  },
});

const select = new LevelSelect(overlay, {
  onPlay: (id) => {
    select.hide();
    game.start(id);
  },
  onBack: () => {
    select.hide();
    title.show();
  },
});

const game = new Game(canvas, overlay, {
  onExit: () => {
    select.show(); // 重新讀取進度並顯示
  },
});

// ---- 螢幕尺寸 ----
function resize() {
  const dpr = window.devicePixelRatio || 1;
  game.layout(window.innerWidth, window.innerHeight, dpr);
}
window.addEventListener('resize', resize);
window.addEventListener('orientationchange', resize);
resize();

// ---- 鎖定手機縮放，避免畫面走位 ----
// 雙指捏合與 Safari 的 gesture 予以阻擋（viewport meta 已設 maximum-scale=1）
document.addEventListener('gesturestart', (e) => e.preventDefault());
document.addEventListener('touchmove', (e) => {
  if (e.touches && e.touches.length > 1) e.preventDefault();
}, { passive: false });
// 連續輕點也不觸發系統放大
let lastTap = 0;
document.addEventListener('touchend', (e) => {
  const now = Date.now();
  if (now - lastTap < 300) e.preventDefault();
  lastTap = now;
}, { passive: false });

// 進入點：顯示標題畫面
title.show();
